export default "__VITE_ASSET__ff042440__"